// Decide se um título está em recorrência comparando sua forma de pagamento
// com a lista `recurrent_payment_methods` da empresa (string separada por
// vírgula ou ponto-e-vírgula). Espelha o BondFilter do app-cliente.
export default function isRecurrent(formaPagamento, recurrentPaymentMethods) {
  if (!recurrentPaymentMethods || recurrentPaymentMethods.trim() === '') {
    return false;
  }

  const recurrentList = recurrentPaymentMethods
    .split(/[;,]/)
    .map(item => item.trim().toLowerCase())
    .filter(item => item !== '');

  const paymentMethod = formaPagamento
    ? String(formaPagamento).trim().toLowerCase()
    : '';

  return paymentMethod !== '' && recurrentList.includes(paymentMethod);
}

// Decide se o toggle "Adicionar recorrência" deve aparecer no Checkout.
// `companyInfo` vem da lista `companies` do login/sessão (POST /customer/portal/session),
// não de GET /empresa/{cnpj} — esse endpoint não expõe recurrence_enabled no
// schema Mongoose de backend-virtus (mesma fonte usada pelo app-cliente).
// Ausência do campo ou `false` = não habilitado (fallback seguro).
export function isRecurrenceEnabled(companyInfo) {
  return companyInfo?.recurrence_enabled === true;
}

// Resolve o valor de `ativar_recorrencia` a enviar no payload de pagamento.
// Nunca `true` se o CNPJ não estiver habilitado, mesmo que o state do toggle
// divirja da visibilidade real do componente.
export function resolveActivateRecurrence(recurrenceEnabled, toggleValue) {
  return Boolean(recurrenceEnabled) && Boolean(toggleValue);
}

// Monta o objeto `recorrencia` a incluir no payload de pagamento quando a
// recorrência foi ativada, a partir dos dados já obtidos na tokenização do
// cartão (newCustomer + newPaymentProfile). Espelha o formato usado pelo
// app-cliente em buildPaymentPayload.ts.
export function buildRecurrencePayload(customerId, paymentProfile, holderName) {
  return {
    idClienteVindi: Number(customerId),
    idPerfilPgto: paymentProfile.payment_profile.id,
    nomeClienteCartao: holderName,
    ultimosDigitosCartao: paymentProfile.payment_profile.card_number_last_four,
    validade: paymentProfile.payment_profile.card_expiration,
    bandeira: paymentProfile.payment_profile.payment_company.code,
    token: paymentProfile.payment_profile.token,
  };
}

// Campo `recorrencia` a espalhar no payload de pagamento: presente somente
// quando a recorrência foi ativada, ausente (objeto vazio) caso contrário.
// Extraído do Checkout para ficar testável sem depender de teste de página.
export function buildRecurrenceField(
  isActivated,
  customerId,
  paymentProfile,
  holderName,
) {
  return isActivated
    ? { recorrencia: buildRecurrencePayload(customerId, paymentProfile, holderName) }
    : {};
}
